import { CreditCard, ArrowRight } from "lucide-react";
import { FINANCING_MIN, PROMO_HEADLINE } from "../data/financing";

export function FinancingStrip() {
  return (
    <section className="bg-[var(--brand-light-gray)] py-8 md:py-10">
      <div className="mx-auto max-w-[1200px] px-4">
        <div className="rounded-lg border border-gray-200 bg-white p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
          <div className="w-11 h-11 rounded-md bg-[var(--brand-red)]/10 text-[var(--brand-red)] flex items-center justify-center shrink-0">
            <CreditCard size={22} />
          </div>
          <div className="flex-1">
            <h3
              className="text-[var(--brand-deep-blue)] text-lg md:text-xl uppercase leading-tight"
              style={{ fontFamily: "var(--font-display)", fontWeight: 700 }}
            >
              Financing Available — {PROMO_HEADLINE}
            </h3>
            <p className="mt-1.5 text-[var(--brand-charcoal)]/85 text-sm md:text-base leading-relaxed">
              Spread the cost of your project over time. Available on projects starting at $
              {FINANCING_MIN}. Checking your options takes about a minute and won't affect
              your credit score.
            </p>
          </div>
          <a
            href="/financing"
            className="inline-flex items-center justify-center gap-2 rounded-md bg-[var(--brand-deep-blue)] text-white px-5 py-3 text-sm uppercase tracking-wide hover:opacity-90 transition-opacity shrink-0"
            style={{ fontFamily: "var(--font-display)", fontWeight: 700 }}
          >
            See Financing Options
            <ArrowRight size={16} strokeWidth={2.5} />
          </a>
        </div>
      </div>
    </section>
  );
}
